import React from 'react';
import { unitStatusColors, unitStatusLabels } from '../../../../helpers/unitStatusConfig';

/**
 * Painel de estatísticas do mapa de vendas (contadores por status + total).
 */
function SalesMapStats({ stats, totalUnits }) {
    return (
        <div className="sales-map-stats">
            {Object.entries(unitStatusColors).map(([key]) =>
                stats[key] ? (
                    <div
                        key={key}
                        className="sales-map-stat-item"
                        style={{ borderLeft: `4px solid ${unitStatusColors[key]}` }}
                    >
                        <span className="stat-count">{stats[key]}</span>
                        <span className="stat-label">{unitStatusLabels[key]}</span>
                    </div>
                ) : null
            )}
            <div className="sales-map-stat-item" style={{ borderLeft: '4px solid #2c3e50' }}>
                <span className="stat-count">{totalUnits}</span>
                <span className="stat-label">Total</span>
            </div>
        </div>
    );
}

export default SalesMapStats;
